import styled from 'styled-components';
import { colorPallet } from 'src/styles/theme/colors';
import { isMobile } from 'react-device-detect';

const divider = [0, 1, 2, 4, 5, 6, 8, 9, 10];

export const MonthCalendarContainer = styled.div<{
  index: number;
  key: number;
  selectedMonth: boolean;
}>`
  display: inline-block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 1rem;
  margin-top: 1rem;

  [class*='ms-slideDownIn10'] {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .root-113 {
    padding: 0;
    @media (max-width: 1072px) {
      border-left: none;
      border-right: none;
      padding-left: 0;
      padding-right: 0;
    }

    @media (min-width: 1980px) {
      [class*='ms-slideDownIn10'] {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      border-left: none;
      border-right: none;

      padding-left: unset;
      padding-right: unset;

      padding-right: ${(props) => divider.includes(props.index) && `1.2rem`};
      margin-left: ${(props) => !divider.includes(props.index) && `-1rem`};
    }
  }

  table {
    max-height: ${() => (isMobile ? 'unset' : '160px')};
    display: ${() => (isMobile ? 'table' : 'flex')};
    margin-bottom: ${() => (isMobile ? 'unset' : '0')};
    zoom: ${() => (isMobile ? '1' : '1.1')};
  }
  td {
    color: ${(props) => props.theme.calendarDateColor};
  }
  [class*='monthAndYear'] {
    display: none;
  }
  td[aria-disabled='false'] {
    span {
      font-weight: 550;
    }
  }
  th {
    color: ${(props) => props.theme.calendarDateColor};
  }
  [class*='ms-CalendarDay-hoverStyle'] {
    background: unset;
  }

  [class*='ms-CalendarDay-daySelected'][aria-selected*='true'] {
    color: ${colorPallet.white};
  }

  [class*='ms-CalendarDay-daySelected'][aria-selected*='true']::before,
  [class*='dayOutsideBounds-']::before,
  [class*='ms-CalendarDay-daySelected'][aria-selected*='true'],
  [class*='dayOutsideBounds-'] {
    border-color: ${(props) => !props.selectedMonth && colorPallet.white};
    border-radius: 0;
  }
  [class*='ms-CalendarDay-daySelected'] [id*='id__'],
  [class*='ms-CalendarDay-daySelected'] [class*='dayButton-'] {
    background: ${(props) =>
      !props.selectedMonth && props.theme.backgroundCalendarDay};
  }
  [aria-current*='date'],
  [class*='ms-CalendarDay-daySelected'][aria-disabled*='true'] {
    background: unset !important;
  }

  [class*='ms-CalendarDay-daySelected'][aria-selected*='true']::before,
  [class*='dayOutsideBounds-']::before,
  [class*='ms-CalendarDay-daySelected'][aria-selected*='true'],
  [class*='dayOutsideBounds-'] {
    border-color: ${(props) =>
      !props.selectedMonth && props.theme.backgroundCalendarDay};
  }

  [class*='ms-CalendarDay-daySelected'] span {
    color: ${(props) =>
      props.selectedMonth
        ? props.theme.calendarDateColor
        : props.theme.calendarDateColor} !important;
  }
  [class*='dayOutsideBounds-'] span {
    color: ${(props) => props.theme.datePickerDisabledDates} !important;
  }
  [class*='dayCell'] {
    position: relative;
  }

  [class*='dayCell'],
  [class*='dayButton-'] {
    cursor: default;
  }
`;

export const MonthLabel = styled.label`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: -1.75rem;
  font-weight: 600;
`;

export const CalendarStyleProps = {
  root: {
    selectors: {
      '& > div > div > div': {
        height: '0px',
        display: 'none',
        zIndex: 1,
      },
    },
  },
};
